import React, { useCallback, useEffect, useState } from "react";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import PagesFiltersToolsBar from "../components/PagesFiltersToolsBar";
import Swal from "sweetalert2";
import PaginationComponent from "../components/Pagination";
import EmptyListWarning from "../components/EmptyListWarning/EmptyListWarning";
import UserListCard from "../components/UserListCard";
import { useAPI } from "app/hooks/useApi";
import HeaderPages from "../components/HeaderPages";
import LogsDownloadsRPIsCards from "../components/LogsDownloadsRPIsCards";

const LogsDownloadsRPIs = () => {
  const [count, setCount] = useState(100);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [searchTerm, setSearchTerm] = useState("");
  const [logs, setLogs] = useState([]);

  const { makeRequest } = useAPI();

  const getLogs = useCallback(async () => {
    let url = `/logs-downloads-rpis-weekly?page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

    if (searchTerm) {
      url += `&searchTerm=${searchTerm}`;
    }

    const response = await makeRequest(url, "GET");

    if (response.status === 200) {
      setLogs(response.data.logs);
      setCount(response.data.total);
    }
  }, [page, perPage, sortBy, sortOrder, searchTerm]);

  const handleSearch = useCallback(() => {
    getLogs();
  }, [searchTerm, getLogs]);

  useEffect(() => {
    getLogs();
  }, [getLogs]);

  return (
    <JumboContentLayout
      header={<HeaderPages title={"Logs de Downloads das RPIs"} />}
    >
      <PagesFiltersToolsBar
        value={searchTerm}
        setValue={setSearchTerm}
        onSearch={handleSearch}
      />

      {logs && logs.length > 0 ? (
        logs.map((log) => <LogsDownloadsRPIsCards log={log} />)
      ) : (
        <EmptyListWarning />
      )}

      <PaginationComponent
        count={count}
        page={page}
        perPage={perPage}
        sortBy={sortBy}
        sortOrder={sortOrder}
        setPage={setPage}
        setPerPage={setPerPage}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
      />
    </JumboContentLayout>
  );
};

export default React.memo(LogsDownloadsRPIs);
